import { Injectable } from '@angular/core';
import { SaveFormActionHandlerService } from './save.service';
import { FormDataService } from '../data.service';
import { FormShareService } from '../share.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { EmailService } from '../../../email/services/email.service';
import { PublishSubscribeService } from '../../../fastlane-common/services/publish-subscribe.service';
import { AttachmentsService } from '../../../project/services/attachments.service';
import {NavService} from '../../../fastlane-common/services/nav.service';

@Injectable()
export class SaveCreditsFormActionHandlerService extends SaveFormActionHandlerService {
  constructor(
    public attachmentService: AttachmentsService,
    public formDataService: FormDataService,
    public formShareService: FormShareService,
    public formStatusService: FormStatusService,
    public swalService: SwalService,
    public userContextService: UserContextService,
    public emailService: EmailService,
    public pubSubService: PublishSubscribeService,
    public navService: NavService
  ) {
    super(
      attachmentService,
      formDataService,
      formShareService,
      formStatusService,
      swalService,
      userContextService,
      pubSubService,
      emailService,
      navService
    );
  }

  exec(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      super
        .exec()
        .then(() => {
          that.swalService.load(
            'Saving your Credits...',
            'This will only take a second.'
          );
          that.formDataService.saveCredits().subscribe(
            () => {
              that.swalService
                .success({ title: 'Successfully saved Credits!' })
                .then(resolve)
                .catch(resolve);
            },
            () => reject('An error occurred while saving your credits.')
          );
        })
        .catch(reason => {
          // Action failure! No cake for you
          that.swalService.error({
            title: 'Oops!',
            text: reason
          });
        });
    });
  }
}
